var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"overflow":"hidden"}},[_c('div',{ref:"canvas",staticStyle:{"height":"300px","width":"600px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }